import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../shared/context/AuthContext'
import ChatterSidebarLayout from './ChatterSidebarLayout'
import '../../iso-dashboard/styles/IsoDashboard.css'

interface ChatterLayoutProps {
  children: React.ReactNode
  selectedOpportunityId?: string
}

const ChatterLayout: React.FC<ChatterLayoutProps> = ({ children, selectedOpportunityId }) => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    await logout()
  }

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  return (
    <div className="iso-dashboard">
      {/* Main Navigation Sidebar */}
      <div className="iso-sidebar">
        <div className="iso-sidebar-header">
          <div className="iso-brand">
            <span className="iso-brand-icon">🏢</span>
            <span className="iso-brand-text">Partner Portal</span>
          </div>
        </div>
        
        <nav className="iso-sidebar-nav">
          <ul className="iso-nav-list">
            <li className="iso-nav-item">
              <button 
                className="iso-nav-button"
                onClick={() => handleNavigation('/iso-dashboard')}
                type="button"
              >
                <i className="bi bi-speedometer2 iso-nav-icon"></i>
                <span className="iso-nav-text">Dashboard</span>
              </button>
            </li>
            <li className="iso-nav-item">
              <button 
                className="iso-nav-button"
                onClick={() => handleNavigation('/submit-deal')}
                type="button"
              >
                <i className="bi bi-plus-circle iso-nav-icon"></i>
                <span className="iso-nav-text">Submit Deal</span>
              </button>
            </li>
            <li className="iso-nav-item">
              <button 
                className="iso-nav-button"
                onClick={() => handleNavigation('/iso-dashboard?tab=deals')}
                type="button"
              >
                <i className="bi bi-list-ul iso-nav-icon"></i>
                <span className="iso-nav-text">View Deals</span>
              </button>
            </li>
            <li className="iso-nav-item">
              <button 
                className="iso-nav-button active"
                onClick={() => handleNavigation('/chatter')}
                type="button"
              >
                <i className="bi bi-chat-dots iso-nav-icon"></i>
                <span className="iso-nav-text">Chatter</span>
              </button>
            </li>
          </ul>
        </nav>

        <div className="iso-sidebar-footer">
          <div className="iso-user-info">
            <div className="iso-user-name">{user?.name}</div>
            <div className="iso-user-role">ISO Partner</div>
          </div>
          <button 
            className="iso-logout-btn"
            onClick={handleLogout}
          >
            <i className="bi bi-box-arrow-right me-2"></i>
            Logout
          </button>
        </div>
      </div>

      {/* Chatter Content Area */}
      <ChatterSidebarLayout selectedOpportunityId={selectedOpportunityId}>
        {children}
      </ChatterSidebarLayout>
    </div>
  )
}

export default ChatterLayout
